const getUniqueRowId = (existing: { [key in string]: boolean }, rowId: string): string => {
  if (!existing[rowId]) {
    existing[rowId] = true;
    return rowId;
  }
  return getUniqueRowId(existing, `${rowId}_x`);
};

export default getUniqueRowId;
